// Google AdSense integration — fully env-driven so it's a no-op until a
// Publisher ID is configured. Set REACT_APP_ADSENSE_CLIENT (ca-pub-...)
// to activate. Feed ad units also need REACT_APP_ADSENSE_FEED_SLOT.
import { useEffect, useRef } from "react";

export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
export const ADSENSE_FEED_SLOT = process.env.REACT_APP_ADSENSE_FEED_SLOT || "";

// Injects the adsbygoogle.js loader once, site-wide. Mount at app root so
// Google can verify the site during application review. Renders nothing.
export function AdSenseScript() {
  useEffect(() => {
    if (!ADSENSE_CLIENT) return;
    if (document.querySelector("script[data-adsbygoogle-loader]")) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    s.crossOrigin = "anonymous";
    s.setAttribute("data-adsbygoogle-loader", "1");
    document.head.appendChild(s);
  }, []);
  return null;
}

// A single responsive ad unit. No-op when not configured, so the layout
// stays clean before AdSense is live.
export function AdSlot({ slot, className = "", style, format = "auto", layout }) {
  const ref = useRef(null);
  const pushed = useRef(false);
  useEffect(() => {
    if (!ADSENSE_CLIENT || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (_) {}
  }, [slot]);

  if (!ADSENSE_CLIENT || !slot) return null;
  return (
    <div ref={ref} className={className} data-testid="adsense-slot">
      <ins
        className="adsbygoogle"
        style={{ display: "block", ...style }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
        {...(layout ? { "data-ad-layout": layout } : {})}
      />
    </div>
  );
}

// In-feed ad card styled to sit naturally between post cards. Spans the
// full grid row so it doesn't get squeezed into a card column.
export function FeedAd() {
  if (!ADSENSE_CLIENT || !ADSENSE_FEED_SLOT) return null;
  return (
    <div
      className="col-span-full rounded-3xl border border-cream-200 bg-cream-50 overflow-hidden p-2"
      data-testid="feed-ad"
    >
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted_ink px-3 py-1">Sponsored</div>
      <AdSlot slot={ADSENSE_FEED_SLOT} format="fluid" layout="in-article" />
    </div>
  );
}
